/**
 * @export
 * @class Views
 * App 내의 view와 scene에 의해 화면이 보이는 것을 관리
 */
export default class Views {
  htViews = {
    prev: {
      view: '',
      scene: '',
    },
    current: {
      view: '',
      scene: '',
    },
  };

  constructor() {
    this.htLastState = null;
    this.setEvent();
  }

  setEvent() {
    $(window).on('hashchange', this.onHashchange);
    $(window).on('load', this.onLoad);
  }

  onLoad = () => {
    window.oDebugMode.log('views.js > window onload', true);
    if (this.htLastState) {
      TMON.util.setHashJSON(this.htLastState);
      this.htLastState = null;
    }

    /**
     * 공유받은 상세 팝업 링크를 앱으로 열면 이전 버튼을 누르면 딜 상세 메인 화면이 아닌 티몬 홈으로 이동하는 문제가 있다.
     * 이 문제를 해결하기 위해 상세 팝업을 앱에서 열면 쿼리스트링에 shared, orderno 값이 들어가고 해시값이 없는 딜상세 메인 링크(https://mobile.tmon.co.kr?share=true&orderno=1)로 열리도록 하고
     * shared, orderno 값을 활용하여 상세 팝업이 열리도록 한다.
     */
    const params = new URLSearchParams(new URL(window.location.href).search);
    const shared = params.get('shared');
    const orderNo = params.get('orderno');
    const sharedPopupOpened = sessionStorage.getItem('sharedPopupOpened');
    if (shared && !sharedPopupOpened) {
      sessionStorage.setItem('sharedPopupOpened', true);
      setTimeout(function() {
        window.location.href = `${TMON.htLocal.htURL.www_m_deals}${TMON.htStaticData.sDealNo}#scene=scene-optiondetail&order_no=${orderNo}`;
      }, 100);
    }
  };

  onHashchange = () => {
    if (TMON.view_mode === 'app' && document.readyState !== 'complete') {
      window.oDebugMode.log(
        'views.js > onHashchange > readyState is not complete',
        true
      );
      TMON.oApp.setStorage('toast', '로딩 중입니다. 잠시 기다려 주세요!');
      this.htLastState = TMON.util.getHashJSON();
      history.replaceState(null, 'default', '#');
      return;
    }

    TMON.oApp.setStorage('hasHashChanged', true);
    const sSceneType = TMON.util.getHashJSON().scene;
    // 레이어 닫힘 처리
    if (
      !TMON.util.getHashJSON().layer ||
      TMON.util.getHashJSON().layer !==
        `open-${TMON.oApp.getStorage('sRandomStringForLayer')}`
    ) {
      this.closeLayer();
    }

    let sViewType = 'view-default';
    if (TMON.oApp.htViews && TMON.oApp.htViews.view) {
      sViewType = TMON.oApp.htViews.view;
    }

    // hash의 변화에 의해 setViews()를 호출
    this.setViews(sViewType, sSceneType);
  };

  closeLayer() {
    const welOpenLayer = $(
      '#_layerContainer article:visible, #_layerContainer section'
    );
    // 바닥 스크롤 잠금 해제 : PC 에서는 레이어를 열 때 fixBodyForLayer() 를 하지 않는다.
    if (
      TMON.oApp.sPlatform !== 'PW' &&
      $('body').hasClass('_positionFixedNotToScroll')
    ) {
      TMON.util.unfixBodyForLayer();
    }
    if (welOpenLayer.length > 0) {
      for (let i = 0; welOpenLayer.length > i; i += 1) {
        if ($(welOpenLayer[i]).attr('data-layerId')) {
          TMON.oApp.setStorage(
            'closeLayer',
            $(welOpenLayer[i]).attr('data-layerId')
          );
        }
      }
    }
    // 레이어 숨김
    $('#_layerContainer').hide();
    $('.pop, .popup').hide();
  }

  setViews(sViewType, sSceneType = 'scene-default') {
    let bChangedView = false;
    let bChangedScene = false;

    if (this.htViews.current.view !== sViewType) {
      // view 가 바뀌었다
      bChangedView = true;
      this.htViews.prev.view = this.htViews.current.view;
      this.htViews.current.view = sViewType;
    }

    if (
      this.htViews.current.view !== sViewType ||
      this.htViews.current.scene !== sSceneType
    ) {
      // scene 이 바뀌었다
      bChangedScene = true;
      this.htViews.prev.scene = this.htViews.current.scene;
      this.htViews.current.scene = sSceneType;
    }

    if (bChangedView || bChangedScene) {
      // view 혹은 scene 이 변경되었을 때 onChangeViews()를 호출
      TMON.oApp.onChangeViews(
        this.htViews.current.view,
        this.htViews.current.scene,
        this.htViews.prev.view,
        this.htViews.prev.scene,
        bChangedView,
        bChangedScene
      );
    }
  }
}
